export default __webpack_public_path__ + "static/media/pnd.9b02fa43.png";